import { render, staticRenderFns } from "./PageFeedback.vue?vue&type=template&id=5df1c9e2&scoped=true"
import script from "./PageFeedback.vue?vue&type=script&lang=js"
export * from "./PageFeedback.vue?vue&type=script&lang=js"
import style0 from "./PageFeedback.vue?vue&type=style&index=0&id=5df1c9e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df1c9e2",
  null
  
)

export default component.exports